function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 会議素材（データ）パラメーター　モデル
 */
var UploadDataMaterialsParamInstanceModel =
/**
 * コンストラクタ
 *
 */
function UploadDataMaterialsParamInstanceModel() {
  _classCallCheck(this, UploadDataMaterialsParamInstanceModel);

  this.SessionId = -1;
  this.DataId = -1;
  this.ParamId = -1;
  this.ParamName = "";
  this.ParamValue = "";
};

export { UploadDataMaterialsParamInstanceModel as default };